module.exports = __webpack_public_path__ + "static/media/d12.a7cce37f.png";